import { Link } from 'react-router-dom';
import { serviceAreas } from '../../../mocks/homeData';

export default function ServiceAreas() {
  return (
    <section className="bg-[#080808] py-0 overflow-hidden" id="service-areas">
      {/* Google Maps */}
      <div className="relative h-80 w-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47952!2d-72.5931!3d41.8426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e65da553c4ac79%3A0x3e3e04e7d2888e71!2sSouth%20Windsor%2C%20CT!5e0!3m2!1sen!2sus!4v1710000000000"
          width="100%" height="100%"
          style={{ border: 0, filter: 'grayscale(40%) invert(5%)' }}
          allowFullScreen loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="DBN Garage service area map South Windsor CT Hartford County"
        />
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#080808] to-transparent pointer-events-none" />
        <div className="absolute top-5 left-5 bg-[#0A0A0A]/90 backdrop-blur-sm border border-white/15 rounded-xl px-5 py-3.5">
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-map-pin-fill text-[#FF6B35]" /></span>
            <div>
              <p className="text-white font-bold text-sm">South Windsor, CT</p>
              <p className="text-gray-400 text-xs">Serving all of Hartford County</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-14 items-start">
          <div className="lg:col-span-2">
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              Where We Serve
            </span>
            <h2 className="font-display font-black text-4xl lg:text-5xl text-white leading-tight mb-6">
              South Windsor &amp;
              <br />
              <span className="text-[#FF6B35]">All of Hartford</span>
              <br />
              County
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-6">
              DBN Garage is proudly based in South Windsor, CT. We provide <strong className="text-white">PPF installation</strong>, <strong className="text-white">ceramic coating</strong>, and <strong className="text-white">window tint</strong> to vehicle owners throughout Hartford County and the surrounding region.
            </p>
            <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 border-l-4 mb-6" style={{ borderLeftColor: '#FF6B35' }}>
              <p className="text-white font-bold text-sm mb-1">Not sure if we cover your area?</p>
              <p className="text-gray-500 text-xs mb-4">Call us — most clients are within 45 minutes of our South Windsor shop.</p>
              <a href="tel:+18605550127"
                className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer w-fit text-sm">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-sm" /></span>
                (860) 555-0127
              </a>
            </div>
            <Link to="/service-areas"
              className="inline-flex items-center gap-2 text-[#FF6B35] text-sm font-bold hover:underline cursor-pointer">
              View All Service Areas
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
            </Link>
          </div>

          <div className="lg:col-span-3">
            <p className="text-white/50 text-xs font-black uppercase tracking-widest mb-5">Cities We Serve</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {serviceAreas.map((area) => (
                <Link key={area} to="/service-areas"
                  className="group flex items-center gap-2 bg-[#111111] border border-white/8 hover:border-[#FF6B35]/50 hover:bg-[#FF6B35]/10 rounded-xl px-4 py-3 transition-all cursor-pointer">
                  <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-fill text-[#FF6B35] text-xs" />
                  </span>
                  <span className="text-gray-400 group-hover:text-white text-sm font-medium transition-colors whitespace-nowrap">{area}</span>
                </Link>
              ))}
            </div>
            <div className="mt-8 bg-[#111111] border border-white/10 rounded-2xl p-6">
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/15 rounded-xl flex-shrink-0">
                  <i className="ri-building-4-fill text-[#FF6B35] text-xl" />
                </span>
                <div>
                  <p className="text-white font-bold text-base mb-1">Locally Owned &amp; Operated — South Windsor, CT</p>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    DBN Garage is a locally-owned automotive protection studio. We're Hartford County car enthusiasts serving our community with the same passion and precision we'd want for our own vehicles.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
